export const enum preferenceConstants {
  
  //Get Preference
  getPreferenceRequest = "GET_PREFERENCE_REQUEST",
  getPreferenceSuccess = "GET_PREFERENCE_SUCCESS",
  getPreferenceFailure = "GET_PREFERENCE_FAILURE",

  //Get Preference By Phone (public endpoint)
  getPreferenceByPhoneRequest = "GET_PREFERENCE_BY_PHONE_REQUEST",
  getPreferenceByPhoneSuccess = "GET_PREFERENCE_BY_PHONE_SUCCESS",
  getPreferenceByPhoneFailure = "GET_PREFERENCE_BY_PHONE_FAILURE",

  //Save Preference
  savePreferenceRequest = "SAVE_PREFERENCE_REQUEST",
  savePreferenceSuccess = "SAVE_PREFERENCE_SUCCESS",
  savePreferenceFailure = "SAVE_PREFERENCE_FAILURE",
}
